export class OwiInstantMessage {
  public convId: string;
  public msgDate: string;
  public msgFrom: string;
  public msgTo: string;
  public msgContent: string;
  public subject: string;

  constructor(convId: string, msgDate: string, msgFrom: string, msgTo: string, msgContent: string, subject: string) {
    this.convId = convId;
    this.msgDate = msgDate;
    this.msgFrom = msgFrom;
    this.msgTo = msgTo;
    this.msgContent = msgContent;
    this.subject = subject;
  }
}
